<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :school="1"
                :status="'HISTORY'"
                :title="'예약 신청내역'"
            />
            <sub-header
                :title="`총 ${reservations.length}건`"
            />
            <div class="content">
                <div class="no-content" v-if="!reservations || reservations.length === 0">
                    신청한 방문예약이 없습니다.
                </div>
                <div
                    class="content-table history-item"
                    v-for="(item, i) in reservations"
                    :key="i"
                    @click="handleDetail(item)">
                    <div class="content-table__row">
                        <div class="content-table__col label" :class="item.status">
                            {{getStatusMessage(item.status)}}
                        </div>
                        <div class="content-table__col teacher-name" v-html="`${item.reservedTeacherName} 선생님`"></div>
                    </div>
                    <div>
                        <div class="content-table__col reserved-dt" v-html="`${item.reservedDate} ${item.reservedTime}`">
                        2024. 9. 10.(화) 14:00
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import SubHeader from "@/components/common/SubHeader.vue";
import { store } from "@/store";
import api from "@/api";

export default {
    name: "ReservationHistory",
    components: { SubHeader, GlobalHeader },
    data: () => ({
        store,
        reservations: []
    }),
    computed: {

    },
    methods: {
        async getReservations() {
            let params = {
                user_type: store.auth.type,
                token: store.auth.token,
                school_id: store.school.id,
            }
            this.reservations = await api.getReservations(params);
        },
        getStatusMessage(reservedStatus) {
            switch(reservedStatus) {
                case "WAITING": return "대기";
                case "ACCEPTED": return "승인";
                case "DENIED": return "반려";
                case "CANCELED": return "취소";
                default: return "";
            }
        },
        handleDetail(item) {
            this.$router.push({ path: `/schools/${store.school.id}/visit/history/${item.reservationId}`});
        }
    },
    mounted() {
        // 학교정보 없으면 초기화면으로 보냄
        if(!store.school.id) {
            this.$router.replace({ path: `/schools/${this.$route.params.school}/visit` });
        }

        this.getReservations();
    },
};
</script>

<style scoped lang="scss">

</style>